
import * as en from './en.json';

export const AllLocales = {
  en
};



// WEBPACK FOOTER //
// ./locales/index.ts